import { render, staticRenderFns } from "./AssignToClassSuccessModal.vue?vue&type=template&id=9a8b5eb6&scoped=true&"
import script from "./AssignToClassSuccessModal.vue?vue&type=script&lang=js&"
export * from "./AssignToClassSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignToClassSuccessModal.vue?vue&type=style&index=0&id=9a8b5eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8b5eb6",
  null
  
)

export default component.exports